import { DocumentsDataTableDocument } from 'generated/resources/datatable.graphql'
import {
  DocumentsDocument,
  RestoreFromTrashBinDocument,
  RestoreFromTrashBinMutation,
  RestoreFromTrashBinMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useRestoreFromTrashBinDocument = ({ fromDataTable = false }: { fromDataTable?: boolean }) => {
  const [restoreDocumentsFromTrashBin, { loading }] = useMutation(RestoreFromTrashBinDocument, {
    extractorFn: (data: RestoreFromTrashBinMutation) =>
      data.documentsMutations.restoreFromTrashBinDocumentsDocument,
  })

  return {
    loading,
    restoreDocumentsFromTrashBin(variables: RestoreFromTrashBinMutationVariables) {
      return restoreDocumentsFromTrashBin({
        variables,
        awaitRefetchQueries: true,
        ...(fromDataTable
          ? {
              refetchQueries: [DocumentsDataTableDocument],
            }
          : {
              refetchQueries: [DocumentsDocument],
            }),
      })
    },
  }
}

export default useRestoreFromTrashBinDocument
